import React from 'react';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const KeyMoments = () => {
  const { language } = useLanguage();
  const content = weddingData[language].keyMoments;

  const moments = [
    {
      ...content.civil,
      icon: Calendar,
      gradient: 'from-lilac-100 to-lilac-50',
      iconColor: 'text-lilac-400',
      hoverGradient: 'group-hover:from-gold-100 group-hover:to-gold-50'
    },
    {
      ...content.religious,
      icon: Calendar,
      gradient: 'from-gold-100 to-gold-50',
      iconColor: 'text-gold-500',
      hoverGradient: 'group-hover:from-lilac-100 group-hover:to-lilac-50'
    },
    {
      ...content.reception,
      icon: MapPin,
      gradient: 'from-lilac-100 to-lilac-50',
      iconColor: 'text-lilac-400',
      hoverGradient: 'group-hover:from-gold-100 group-hover:to-gold-50'
    }
  ];

  const scrollToMaps = () => {
    window.location.href = '/maps';
  };

  return (
    <section className="py-32 bg-gradient-to-br from-ivory via-lilac-50 to-ivory relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-lilac-200 rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-200 rounded-full filter blur-3xl" />
      </div>

      <div className="container mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl sm:text-5xl font-playfair font-bold text-plum-900 mb-6">
            {content.title}
          </h2>
          <p className="text-xl text-plum-800 font-montserrat max-w-3xl mx-auto">
            {content.subtitle}
          </p>
          <div className="divider-gold mt-8" />
        </div>

        {/* Moments Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-7xl mx-auto">
          {moments.map((moment, index) => (
            <div
              key={index}
              className="group card-premium hover-lift"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="text-center">
                {/* Icon */}
                <div className={`w-24 h-24 mx-auto mb-8 bg-gradient-to-br ${moment.gradient} ${moment.hoverGradient} rounded-full flex items-center justify-center shadow-soft transition-all duration-500`}>
                  <moment.icon className={`${moment.iconColor} group-hover:text-gold-500 transition-colors duration-500`} size={48} />
                </div>

                {/* Title */}
                <h3 className="text-3xl font-playfair font-bold text-plum-900 mb-6 group-hover:text-gold-600 transition-colors duration-500">
                  {moment.title}
                </h3>

                {/* Date & Time */}
                <div className="space-y-4 mb-6">
                  <div className="flex items-center justify-center space-x-3 text-plum-800">
                    <Calendar size={20} className="text-gold-500" />
                    <span className="font-montserrat text-base font-medium">{moment.date}</span>
                  </div>
                  <div className="flex items-center justify-center space-x-3 text-plum-700">
                    <Clock size={20} className="text-lilac-400" />
                    <span className="font-montserrat text-sm">{moment.time}</span>
                  </div>
                </div>

                <div className="divider-lilac my-6" />

                {/* Location */}
                <div className="mb-6">
                  <p className="text-xl font-playfair font-semibold text-plum-900 mb-2">
                    {moment.location}
                  </p>
                  <p className="text-sm text-plum-700 font-montserrat">
                    {moment.address}
                  </p>
                </div>

                {/* View Map Button */}
                <button
                  onClick={scrollToMaps}
                  className="btn-primary inline-flex items-center space-x-2"
                >
                  <MapPin size={18} />
                  <span>{moment.viewMap}</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyMoments;
